import { z } from 'zod';

export const OrganizationPermissionGroupItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
  scopeType: z.enum(['TENANT', 'PLACE']),
});

export type OrganizationPermissionGroupItem = z.infer<typeof OrganizationPermissionGroupItemSchema>;

export const ListOrganizationPermissionGroupsResponseSchema = z.object({
  organizationId: z.uuid(),
  items: z.array(OrganizationPermissionGroupItemSchema),
});

export type ListOrganizationPermissionGroupsResponse = z.infer<
  typeof ListOrganizationPermissionGroupsResponseSchema
>;
